<template>
  <div class="header">
    <Header></Header>
    <!-- banner -->
    <div class="bannerBox">
      <div class="container">
        <div class="storyTxt">
          <img height="50px" v-if="dataTotal>0" src="../../assets/picture/search.png">
          <img height="50px" v-else src="../../assets/picture/nosearch.png">
        </div>
        <img class="fr mt30" width="300px" src="../../assets/picture/responsibility/t10.png">
      </div>
    </div>
    <!-- section1 -->
    <div class="section1">
      <ul class="container">
        <li v-for="(item,index) in list" :key="index">
          <img width="384px"  @click="goDetail(item.id)" :src="item.thumbnail?item.thumbnail:require('../../assets/picture/blank.png')">
          <div class="liBox">
            <h5>{{item.title}}</h5>
            <p>{{item.content}}</p>
            <div class="date" @click="goDetail(item.id)">
              <span>查看详情</span>
              <img width="11px" src="../../assets/picture/occupation/more.png">
            </div>
          </div>
        </li>
      </ul>
       <div class="pagination">
         <el-pagination class="pagination" @current-change="handleChangePage" :total="dataTotal"
          @size-change="handleSizeChange" :current-page.sync="fromData.pageNum"
            layout="prev, pager, next" :page-size="fromData.pageSize">
          </el-pagination>
      </div>   
    </div>
    <!-- footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../common/header';
import Footer from '../common/footer';
import {formatDate} from '../../plugins/formatDate.js'
export default {
  data() {
    return {
      isShowSearch:false,
        fromData:{
          pageNum:1,
          pageSize:10,
          keyword:''
      },
      dataTotal:0,
      list:[],
    };
  },
  components: { Header,Footer },
  mounted(){
    this.fromData.keyword = this.$route.query.keyword;
    if(!this.fromData.keyword){
      this.fromData.keyword = window.sessionStorage.getItem("keyword");
    }
    this.loadData();
  },
  filters: {
      formatDate(time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate(date, 'yyyy-MM-dd hh:mm')
      }
  },
  methods: {
    showSearch(){
      this.isShowSearch = !this.isShowSearch;
    },
      async loadData() {
        const { data: res } = await this.$http.get("/global/searchResultByPage.do?pageNum="+this.fromData.pageNum+"&pageSize="+this.fromData.pageSize+"&keyword="+this.fromData.keyword);
        // 提示message
        if (res.code !== 200) return this.$message.error(res.message);
        this.$router.push({  
            path: '/search',       
        })
       this.list = res.data.list;
       this.dataTotal = res.data.total;
    },
    handleChangePage(pageNum) {
      this.fromData.pageNum = pageNum;
      this.loadData();
    },
    // 切换单页数量事件
    handleSizeChange(pageSize) {
      this.fromData.pageSize = pageSize;
      this.loadData();
    },
    goDetail(id){
       this.$router.push({  
            path: '/searchDetail',  
            query: {   
              id: id,   
            }   
        })
    }
  }
};
</script>

<style lang="less" scoped>
.header{
  .bannerBox{    
    width: 100%;
    height: 360px;
    background: #333333;
    display: flex;
    .storyTxt{
        display: inline-block;
       img{      
        margin-top: 170px;
      }
    }
  }
  /*********************************************/
  .section1{
    ul{
      li{
        padding:120px 0;
        display: flex;
        border-bottom: 1px solid #D5D5D5;
        img{
          margin-right: 100px;
        }
        .liBox{
          h6{
            margin-bottom: 2px;
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #353535;
            line-height: 20px;
            letter-spacing: 1px;
          }
          h5{
            margin-top: 35px;           
            font-size: 26px;
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 300;
            color: #900211;
            line-height: 37px;
            margin-bottom: 34px;
          }
          p{            
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #9A9A9A;
            line-height: 30px;
            width: 398px;
            margin-bottom: 34px;
            overflow: hidden;      
            text-overflow: ellipsis;      
            display: -webkit-box; /* 将对象作为弹性伸缩盒子模型显示 */      
            -webkit-line-clamp: 4; /* 控制最多显示几行 */      
            -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */ 
          }
          .date{
            span{            
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #900211;
              line-height: 20px;
              margin-right: 10px;
              cursor: pointer;
            };
          }
        }
      }
    }
    .pagination{
      text-align: center;
      margin-top: 55px;
      margin-bottom: 100px;
      /deep/ .el-pager li.active{
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #900211;
      }
      /deep/ .el-pager li{
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #9A9A9A;
      }
      /deep/ .btn-next{
        color:#900211 !important;
      }
      /deep/ .btn-next:hover{
        color:#900211;
      }
    }
  }
}
</style>
